module.exports = __webpack_public_path__ + "static/media/indorsed.8c911c19.svg";